/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Center_LeftInputs */



/**
* | output |
* | --- |
* | "Position Events to the center left of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Center_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_center_left = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Center_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Center_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements au centre gauche de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse links in der Mitte des Videos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi al centro a sinistra del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в левой центральной части видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en el centro izquierdo del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件定位在视频左侧中间位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの中央左に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के केंद्र-बाएँ भाग में घटनाओं को रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos no centro esquerdo do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the center left of the video")
});